export default __webpack_public_path__ + "static/media/m12.668d7448.png";